import React from 'react';
import { BaseLayout } from '../components';

const MobileLayoutDemo: React.FC = () => {
  return (
    <BaseLayout style={{ padding: '20px', color: 'white' }}>
      <h1 className="text-mobile-2xl">Mobile Layout Demo</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <h2 className="text-mobile-lg">Layout Adaptations:</h2>
        <p className="text-mobile-sm">✅ Viewport units (vw, vh) → Container percentages (%)</p>
        <p className="text-mobile-sm">✅ Fixed positioning → Relative to mobile container</p>
        <p className="text-mobile-sm">✅ CSS Custom Properties for responsive scaling</p>
        <p className="text-mobile-sm">✅ Touch-friendly button sizes (44px minimum)</p>
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <h2 className="text-mobile-lg">Responsive Text Sizes:</h2>
        <p className="text-mobile-sm">Small text - Adapts to screen size</p>
        <p className="text-mobile-base">Base text - Optimized for mobile</p>
        <p className="text-mobile-lg">Large text - Clear and readable</p>
        <p className="text-mobile-xl">Extra large text - Headers</p>
        <p className="text-mobile-2xl">2XL text - Titles</p>
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <h2 className="text-mobile-lg">Touch-Friendly Elements:</h2>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button className="touch-button" style={{ backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '8px' }}>
            Daily Quest
          </button>
          <button className="touch-button" style={{ backgroundColor: '#ef4444', color: 'white', border: 'none', borderRadius: '8px' }}>
            Daily Check-in
          </button>
          <button className="touch-button" style={{ backgroundColor: '#10b981', color: 'white', border: 'none', borderRadius: '8px' }}>
            Mini Game
          </button>
          <button className="touch-button" style={{ backgroundColor: '#8b5cf6', color: 'white', border: 'none', borderRadius: '8px' }}>
            KILO HUB
          </button>
        </div>
      </div>
      
      <div className="safe-area-all" style={{ backgroundColor: 'rgba(255,255,255,0.1)', padding: '10px', borderRadius: '8px', marginBottom: '20px' }}>
        <p className="text-mobile-base">Safe area content - Respects device notches and home indicators</p>
      </div>
      
      <div style={{ marginTop: '20px' }}>
        <div className="mobile-only">
          <p className="text-mobile-base">📱 Mobile: This shows on actual mobile devices</p>
        </div>
        <div className="desktop-only">
          <p className="text-mobile-base">🖥️ Desktop: This shows when viewing in mobile container on desktop</p>
        </div>
      </div>
      
      <div style={{ 
        position: 'fixed', 
        bottom: '20px', 
        left: '20px', 
        right: '20px', 
        backgroundColor: 'rgba(0,0,0,0.8)', 
        padding: '15px', 
        borderRadius: '8px',
        fontSize: '12px',
        lineHeight: '1.4'
      }}>
        <strong>🎮 Mobile Layout Status:</strong><br/>
        <span style={{ color: '#10b981' }}>✅ Desktop:</span> Game container (430x932px) with proper scaling<br/>
        <span style={{ color: '#3b82f6' }}>✅ Mobile:</span> Full screen native experience<br/>
        <span style={{ color: '#f59e0b' }}>✅ Responsive:</span> Container-based units (%, em, rem)<br/>
        <span style={{ color: '#ef4444' }}>❌ Removed:</span> Viewport units (vw, vh) for consistency
      </div>
    </BaseLayout>
  );
};

export default MobileLayoutDemo;
